//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash'
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List tips books ----------------
export const handleTipsBook = (bookId) => async (dispatch) => {
    await dispatch(ActivityActions.listTipsBook());
    try {
        let tipsBook = []
        const tipsBookRDS = await apis.get('tipsByBookRDS', `/tipsByBook/${bookId}`);
        if (Array.isArray(tipsBookRDS) && tipsBookRDS.length > 0) {
            tipsBook = tipsBookRDS
        }
        await dispatch(ActivityActions.listTipsBookSuccess(tipsBook));
        return tipsBook;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing tips book',
                error,
                module: 'TIPS',
                operation: 'LIST_TIPS_BOOK'
            });
        }
        await dispatch(ActivityActions.listTipsBookFail(error));
    }
};


export const handleListTipsBook = () => async (dispatch) => {
    await dispatch(ActivityActions.listTipsBook());
    try {
        let tipsBook = []
        const tipsBookRDS = await apis.get('tipsByBookRDS', `/list`);
        if (Array.isArray(tipsBookRDS) && tipsBookRDS.length > 0) {
            tipsBook = tipsBookRDS
        }
        await dispatch(ActivityActions.listTipsBookSuccess(tipsBook));
        return tipsBook;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing tips book',
                error,
                module: 'TIPS',
                operation: 'LIST_TIPS_BOOK'
            });
        }
        await dispatch(ActivityActions.listTipsBookFail(error));
    }
};

export const handleCreateTipsBook = (data) => async (dispatch) => {
    await dispatch(ActivityActions.createTipsBook());
    try {
        const tipsBookRDS = await apis.post('tipsByBookRDS', `/create`, {
            body: data
        });
        if (has(tipsBookRDS, "id")) {
            await dispatch(ActivityActions.createTipsBookSuccess(tipsBookRDS));
        }
        return tipsBookRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating tips book',
                error,
                module: 'TIPS',
                operation: 'CREATE_TIPS_BOOK'
            });
        }
        await dispatch(ActivityActions.createTipsBookFail(error));
    }
};
export const handleUpdateTipsBook = (data) => async (dispatch) => {
    await dispatch(ActivityActions.updateTipsBook());
    try {
        const tipsBookRDS = await apis.put('tipsByBookRDS', `/update`, {
            body: data
        });
        if (has(tipsBookRDS, "id")) {
            await dispatch(ActivityActions.updateTipsBookSuccess(tipsBookRDS));
        }
        return tipsBookRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating tips book',
                error,
                module: 'TIPS',
                operation: 'UPDATE_TIPS_BOOK'
            });
        }
        await dispatch(ActivityActions.updateTipsBookFail(error));
    }
};
export const handleDeleteTipsBook = (id) => async (dispatch) => {
    await dispatch(ActivityActions.deleteTipsBook());
    try {
        const tipsBookRDS = await apis.del('tipsByBookRDS', `/delete/${id}`);
        if (has(tipsBookRDS, "id")) {
            await dispatch(ActivityActions.deletetTipsBookSuccess(id));
        }
        return tipsBookRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting tips book',
                error,
                module: 'TIPS',
                operation: 'DELETE_TIPS_BOOK'
            });
        }
        await dispatch(ActivityActions.deleteTipsBookFail(error));
    }
};

